import { motion } from "framer-motion";

import SectionHeading from "@/components/SectionHeading";
import SmartLink from "@/components/SmartLink";
import { Button } from "@/components/ui/button";
import { iconRegistry } from "@/content/iconRegistry";

export default function ResourcesGridSection({ content, dataTestId, className = "" }) {
  return (
    <section className={`py-16 md:py-24 ${className}`.trim()} data-testid={dataTestId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <SectionHeading title={content.title} description={content.description} />
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {content.cards.map((card, index) => {
            const Icon = iconRegistry[card.icon];

            return (
              <motion.div
                key={card.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-card rounded-3xl p-8 shadow-soft border border-border"
              >
                <div className="w-14 h-14 rounded-2xl bg-secondary/36 flex items-center justify-center mb-5 border border-secondary/45">
                  <Icon className="w-7 h-7 text-highlight" />
                </div>
                <h3 className="font-sans text-xl font-semibold text-foreground mb-3">{card.title}</h3>
                <p className="font-body text-muted-foreground leading-relaxed mb-6">{card.description}</p>
                <Button asChild className="rounded-full bg-secondary hover:bg-secondary/85 text-white font-medium px-6 btn-hover">
                  <SmartLink href={card.cta.href} external={card.cta.external}>
                    {card.cta.label}
                  </SmartLink>
                </Button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
